//import "./App.css";
//import "./_metronic/assets/sass/style.react.scss";
//import "./_metronic/assets/fonticon/fonticon.css";
//import "./_metronic/assets/keenicons/duotone/style.css";
//import "./_metronic/assets/keenicons/outline/style.css";
//import "./_metronic/assets/keenicons/solid/style.css";
//import "./_metronic/assets/sass/style.scss";
//import "bootstrap/dist/css/bootstrap.min.css"; //because it is imported in eyeconxcss
import "./_theme/eyeconx.scss"
import "./components/layout/theme/EcxPageTheme.css"
import "./components/layout/theme/NavIconTheme.css"
import "./components/layout/theme/EcxDatePicker.css"
import "./components/layout/theme/EcxTimePicker.css"
import "./components/layout/theme/EcxSwalTheme.css"
import "bootstrap-icons/font/bootstrap-icons.css";
import "boxicons/css/boxicons.min.css";
import "remixicon/fonts/remixicon.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import AuthLayout from "./components/layout/AuthLayout";
import Login from "./components/auth/Login";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import TermsConditions from "./components/auth/TermsConditions";
import ContactUs from "./components/auth/ContactUs";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./components/pages/dashboard/Dashboard";
import StateObject from "./components/helpers/StateObject";
import PrivateRoutes from "./routings/PrivateRoutes";
import ClinicFeatureRoute from "./routings/ClinicFeatureRoute";
import Appointments from './components/pages/appointments/Appointments'
import PatientFiles from "./components/pages/patientfiles/PatientFiles";
import Surveys from "./components/pages/surveys/Surveys";
import Articles from "./components/pages/articles/Articles";
import Newsletter from "./components/pages/newsletter/Newsletter";
import EmailNewsletterResults from "./components/pages/newsletter/EmailNewsletterResults";
import EyeDrawNew from "./components/pages/eyedraw/EyeDrawNew";
import PmsUpdateHistory from "./components/pages/pms-update-history/PmsUpdateHistory";
import MyFiles from "./components/pages/myfiles/MyFiles";
import Settings from "./components/pages/settings/Settings";
import ArticlePrint from "./components/pages/articles/ArticlePrint";
import Messages from "./components/pages/messages/Messages";
import EmailBlast from "./components/pages/blast_email/EmailBlast";
import EmailBlastResults from "./components/pages/blast_email/EmailBlastResults";
import SmsBlast from "./components/pages/blast_sms/SmsBlast";
import SmsBlastResults from "./components/pages/blast_sms/SmsBlastResults";
import CreateEmail from "./components/pages/blast_email/CreateEmail";
import CreateSms from "./components/pages/blast_sms/CreateSms";
import ClinicSettings from "./components/pages/settings/ClinicSettings";
import SmsDashboard from "./components/smsgateway/pages/smsdashboard/SmsDashboard";
import SmsMessages from "./components/smsgateway/pages/messages/SmsMessages";
import SmsLayout from "./components/smsgateway/layout/SmsLayout";
import SmsChangePassword from "./components/smsgateway/pages/account/SmsChangePassword";
import SmsConversation from "./components/smsgateway/pages/messages/SmsConversation";
import GatewayClinicInfo from "./components/smsgateway/pages/clinicsettings/GatewayClinicInfo";
import Notifications from "./components/smsgateway/pages/notifications/Notifications";
import SmsHelp from "./components/smsgateway/pages/help/SmsHelp";
import Logout from "./components/auth/Logout";
import ReminderSettings from "./components/pages/settings/reminders/ReminderSettings";
import SmsNewsletter from "./components/pages/newsletter/SmsNewsletter";
import SmsNewsletterResults from "./components/pages/newsletter/SmsNewsletterResults";
import CreateEmailNewsletter from "./components/pages/newsletter/CreateEmailNewsletter";
import CreateSmsNewsletter from "./components/pages/newsletter/CreateSmsNewsletter";
import EmailEditorTest from "./components/helpers/email-editor/EmailEditorTest";
import CreateSurveyPage from "./components/pages/surveys/CreateSurveyPage";
import SurveyTemplate from "./components/pages/surveys/SelectTemplate";
import SurveyEditPage from "./components/pages/surveys/SurveyEditPage";
import SurveyResultPage from "./components/pages/surveys/SurveyResultPage";
import SurveyGraphsPage from "./components/pages/surveys/SurveyGraphsPage";
import Features from "./components/pages/settings/features/Features";
import UserSettings from "./components/pages/settings/users/UserSettings";
import PasswordUpdate from "./components/pages/password/PasswordUpdate";
import Reputation from "./components/pages/reputation/Reputation";
import Bookings from "./components/pages/bookings/Bookings";
import Patient from "./components/pages/patientfiles/patient/Patient";
import Templates from "./components/pages/templates/Templates";
import Activity from "./components/pages/activity/Activity";
import InvalidDetails from "./components/pages/invalid-details/InvalidDetails";
import CancellationFollowups from "./components/pages/cancellation-followups/CancellationFollowups";
import ThankYouAndSurveys from "./components/pages/thank-you-surveys/ThankYouAndSurveys";
import Recalls from "./components/pages/recalls/Recalls";
import RecallPools from "./components/pages/recall-pools/RecallPools";
import Invoices from "./components/pages/invoices/Invoices";
import Reports from "./components/pages/reports/Reports";
import OpticalDispensary from "./components/pages/optical-dispensary/OpticalDispensary";
import WebInquiry from "./components/pages/web-inquiry/WebInquiry";
import HelpSupport from "./components/pages/help/HelpSupport";
import WhatsNewPage from "./components/common/WhatsNewPage";
import VerifyEmail from "./components/pages/settings/verifyemail/VerifyEmail";
import ClinicFeaturesLoader from "./modules/clinicFeatures/ClinicFeaturesLoader";
function App() {

  return (
    <BrowserRouter>
      <Routes>

          {/** public routes */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="logout" element={<Logout/>} />
        </Route>

        <Route path="terms-and-conditions" element={<TermsConditions />} />
        <Route path="contact-us" element={<ContactUs />} />

        <Route element={<MainLayout/>}>
            <Route element={<PrivateRoutes/>}>
                <Route path="dashboard" element={<Dashboard/>}/>
                <Route
                    path="appointments"
                    element={
                        <ClinicFeatureRoute featureKey="isAppointments">
                            <Appointments/>
                        </ClinicFeatureRoute>
                    }
                />
                <Route path="web-bookings" element={<Bookings/>}/>
                <Route path="patient-files">
                    <Route index element={<PatientFiles/>}/>
                    <Route path=":patientId" element={<Patient/>}/>
                </Route>
                <Route path="surveys">
                    <Route
                        index
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <Surveys/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path="create-survey"
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <CreateSurveyPage/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path="survey-templates"
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <SurveyTemplate/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path=":surveyId/edit"
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <SurveyEditPage/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path=":surveyId/results"
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <SurveyResultPage/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path=":surveyId/graphs"
                        element={
                            <ClinicFeatureRoute featureKey="survey">
                                <SurveyGraphsPage/>
                            </ClinicFeatureRoute>
                        }
                    />
                </Route>
                <Route path="messages" element={<Messages/>} /> 
               {/*} <Route path="messages">
                    <Route index element={<SmsMessages/>} />
                    <Route path=":conversationId" element={<SmsConversation/>}/> 
                </Route>*/}
                <Route
                    path="web-inquiry"
                    element={
                        <ClinicFeatureRoute featureKey="webInquiry">
                            <WebInquiry/>
                        </ClinicFeatureRoute>
                    }
                />
                <Route
                    path="articles"
                    element={
                        <ClinicFeatureRoute featureKey="isArticle">
                            <Articles/>
                        </ClinicFeatureRoute>
                    }
                />
                <Route path="newsletter">
                        <Route path="email" element={<Newsletter/>}/>
                        <Route path="email/:campaignId/results" element={<EmailNewsletterResults/>}/>
                        <Route path="email-newsletter" element={<Navigate to="/newsletter/email" replace />}/>
                        <Route path="sms" element={<SmsNewsletter/>}/>
                        <Route path="sms/:campaignId/results" element={<SmsNewsletterResults/>}/>
                        <Route path="sms-newsletter" element={<Navigate to="/newsletter/sms" replace />}/>
                        <Route path="create-email" element={<CreateEmailNewsletter/>}/>
                        <Route path="create-sms" element={<CreateSmsNewsletter/>}/>
                </Route>
                <Route path="blast">
                  <Route path="email" element={<EmailBlast/>} />
                  <Route path="email/:campaignId/results" element={<EmailBlastResults/>} />
                  <Route path="create-email" element={<CreateEmail/>} />
                  <Route path="sms" element={<SmsBlast/>} />
                  <Route path="sms/:campaignId/results" element={<SmsBlastResults/>} />
                  <Route path="create-sms" element={<CreateSms/>}/>
                </Route>
                <Route path="reputation" element={<Reputation/>}/>
                <Route path="recalls">
                    <Route index element={<Navigate to="requests" replace />}/>
                    <Route
                        path="requests"
                        element={
                            <ClinicFeatureRoute featureKey="recall">
                                <Recalls/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path="pool"
                        element={
                            <ClinicFeatureRoute featureKey="recall">
                                <RecallPools/>
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path="pool/:poolId/edit"
                        element={<Navigate to="/recalls/pool" replace />}
                    />
                </Route>
                <Route path="recall-pools" element={<Navigate to="/recalls/pool" replace />}/>
                <Route
                    path="recall-pools/:poolId/edit"
                    element={<Navigate to="/recalls/pool" replace />}
                />
                <Route path="email-editor-test" element={<EmailEditorTest/>} />
                <Route path="eye-draw" element={<EyeDrawNew/>}/>
                <Route path="optical-dispensary">
                    <Route
                        index
                        element={<Navigate to="pickups" replace />}
                    />
                    <Route
                        path="pickups"
                        element={
                            <ClinicFeatureRoute featureKey="isOpticalDispensary">
                                <OpticalDispensary />
                            </ClinicFeatureRoute>
                        }
                    />
                    <Route
                        path="cl-orders"
                        element={
                            <ClinicFeatureRoute featureKey="isOpticalDispensary">
                                <OpticalDispensary />
                            </ClinicFeatureRoute>
                        }
                    />
                </Route>
                <Route path="pms-update-history" element={<PmsUpdateHistory/>} />
                <Route path="my-files" element={<MyFiles/>}/>
                <Route path="invoices" element={<Invoices/>}/>
                <Route path="reports" element={<Reports/>}/>
                <Route path="activity" element={<Activity/>}/>
                <Route path="cancellation-followups" element={<CancellationFollowups/>}/>
                <Route path="patient-engagement" element={<ThankYouAndSurveys/>}/>
                <Route path="invalid-details" element={<InvalidDetails/>}/>
                <Route path="settings">
                    <Route path="clinic" element={<ClinicSettings/>}/>
                    <Route path="clinic-info" element={<Settings/>}/>
                    <Route path="verify-email" element={<VerifyEmail/>}/>
                    <Route path="reminders" element={<ReminderSettings/>} />
                    <Route path="features" element={<Features/>} />
                    <Route path="users" element={<UserSettings/>} />
                    <Route path="templates" element={<Templates/>} />
                </Route>
                <Route path="update-password" element={<PasswordUpdate/>} />
                <Route path="help" element={<HelpSupport/>} />
                <Route path="whats-new" element={<WhatsNewPage/>} />
            </Route>
        </Route>
        {/** sms gateway routes */}
        <Route element={<PrivateRoutes/>}>
          <Route element={<SmsLayout/>}>
          <Route path="sms-dashboard" element={<SmsDashboard/>} />
          <Route path="sms-messages">
              <Route index element={<SmsMessages/>} />  
              <Route path=":conversationId" element={<SmsConversation/>}/>     
          </Route> 
          <Route path="sms-clinic-settings" element={<GatewayClinicInfo/>} />
          <Route path="sms-change-password" element={<SmsChangePassword/>} />
          <Route path="sms-help" element={<SmsHelp/>} />
          <Route path="sms-whats-new" element={<WhatsNewPage/>} />
          <Route path='sms-notifications' element={<Notifications/>} />
        </Route>
        </Route>
        {/** end sms routes */}
        <Route element={<PrivateRoutes/>}>
           {/* Doesnt have main layout. Full Screen  */}
           <Route
               path="print-article/:articleId"
               element={
                   <>
                       <ClinicFeaturesLoader />
                       <ClinicFeatureRoute featureKey="isArticle">
                           <ArticlePrint/>
                       </ClinicFeatureRoute>
                   </>
               }
           />
        </Route>

      <Route path="eyedraw" element={<EyeDrawNew/>}/>

        <Route path="stateobject" element={<StateObject/>} />
      </Routes>
      <ToastContainer position="bottom-right"/>
    </BrowserRouter>
  );
}

export default App;
